<template>
  <div>
    <ld-statusbar bg-white />
    <van-row
      class="full-width navbar default"
      :style="styl"
      type="flex"
      align="center"
      justify="space-between"
    >
      <van-col
        span="3"
        class="left"
        @click="onClickLeft"
        v-if="showLeft()"
      >
        <slot name="left">
          <van-icon
            v-if="!isGat()"
            v-show="leftArrow"
            class="back"
            name="arrow-left"
          />
        </slot>
      </van-col>
      <van-col
        :span="centerSpan"
        class="center"
      >
        <slot>{{ title }}</slot>
      </van-col>
      <van-col
        :span="rightSpan"
        class="right"
        @click="onClickRight"
      >
        <slot name="right">
          {{ rightText }}
        </slot>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import ldStatusbar from 'Common/ldStatusbar'
import { isGat } from 'Utils/gattools'

export default {
  name:'Ldnavbar',
  components:{
    ldStatusbar
  },
  props: {
    title:{
      type:String,
      default:'选择出行人'
    },
    styl:{
      type:Object,
      default:function(){
        return {}
      }
    },
    leftArrow:{//左侧箭头是否显示
      type:Boolean,
      default:true
    },
    rightText:{//右侧文字
      type:String,
      default:''
    },
    order:{
      type:[Boolean,String],
      default:true
    }
  },
  data () {
    return {
      centerSpan:18,
      rightSpan:3,
    }
  },
  mounted(){
    if (!this.$slots['right']) {
      this.centerSpan=21
      this.rightSpan=0
    }
  },
  methods: {
    isGat,
    showLeft(){
      if(isGat()){//是关爱通
        if(this.order=='allorder'){//订单列表不左对齐
          return true
        }else{
          return false
        }
      }else{ //不是关爱通显示
        return true
      }
    },
    onClickLeft () {
      if (this.$listeners['click-left']) {
        this.$emit('click-left')
      } else if (this.leftArrow) {
        this.$router.go(-1)
      }
    },
    onClickRight () {
      this.$emit('click-right')
    }
  },
}
</script>
<style lang="less" scoped>
.navbar{
  position: relative;
  text-align: center;
  user-select: none;
  z-index: 1;
}
.default{
  background-color: @color-background-white;
  height: 54px;
}
.back{
  min-width: 1em;
  font-size: 24px;
}

</style>
